// extracted by mini-css-extract-plugin
export var bgMedia = "MediaTextBlock-module--bgMedia--ddbb8";
export var container = "MediaTextBlock-module--container--63938";
export var content = "MediaTextBlock-module--content--364e0";
export var contentArea = "MediaTextBlock-module--contentArea--ea1f1";
export var layoutTextLeft = "MediaTextBlock-module--layoutTextLeft--e5fff";
export var layoutTextLeftHalf = "MediaTextBlock-module--layoutTextLeftHalf--9bd1d";
export var layoutTextRight = "MediaTextBlock-module--layoutTextRight--88b93";
export var layoutTextRightHalf = "MediaTextBlock-module--layoutTextRightHalf--00a28";
export var layoutTile = "MediaTextBlock-module--layoutTile--310a3";
export var mediaArea = "MediaTextBlock-module--mediaArea--ecfe3";
export var text = "MediaTextBlock-module--text--84591";